module.exports = __webpack_public_path__ + "img/logo.2f5c4b2e.png";